export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10670.f1f572f9.jpg";